import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminMain from './Admin/AdminRouter';
import About from './screens/about/About';
import Contract from './screens/contract/Contract';
import Home from './screens/home/Home';
import Inquiry from './screens/inquiry/Inquiry';
import ProjectDetail from './screens/projects/ProjectDetail';
import Projects from './screens/projects/Projects';

function App() {
  return (
    <Routes>
      <Route path="/about" element={<About />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<ProjectDetail />} />
      <Route path="/inquiry" element={<Inquiry />} />
      <Route path="/service" element={<Navigate to="/about" replace />} />
      <Route path="/contract" element={<Contract />} />
      <Route path="/admin/*" element={<AdminMain />} />
      <Route path="/" element={<Home />} />
    </Routes>
  );
}

export default App;
